import {
  Player,
  PlayerInvite,
  Registrant,
  RegistrationStatus,
  Staff,
  StaffInvite,
  StaffRole,
} from '@la/types';
import { isStaff } from '@la/utilities';

export const mapPlayersToRegistrants = (
  players: (Player | PlayerInvite)[]
): Registrant[] => {
  return players.map((player: Player | PlayerInvite) => ({
    ...player,
    avatarUrl: player.avatarUrl ?? '',
    role: undefined,
    userId:
      player.registrationStatus === RegistrationStatus.PendingInvite
        ? player.registeringUserId
        : (player.registeredUserId ?? 0),
  }));
};

export const mapStaffToRegistrants = (
  staff: (Staff | StaffInvite)[],
  staffRoles: StaffRole[]
): Registrant[] => {
  return staff.map((staff: Staff | StaffInvite) => {
    let isPrimaryStaff = false;
    let role: string | undefined;
    let roleId: number | undefined;

    if (isStaff(staff)) {
      // Registered staff
      if (staff.roles.length > 0) {
        const staffRole = staffRoles.find(
          (r) => r.id === staff.roles[0].roleId
        );
        role = staffRole?.role;
        roleId = staffRole?.id;
        isPrimaryStaff = !!staffRole?.isClubDirector;
      }
    } else {
      // Invited staff
      role = staff.role?.name;
      roleId = staff.role?.roleId;
    }

    return {
      ...staff,
      avatarUrl: staff.avatarUrl ?? '',
      isPrimaryStaff,
      role,
      roleId,
      userId: staff.registeringUserId,
    };
  });
};
